import { ViewportRuler } from '@angular/cdk/overlay';
import { AfterViewInit, Directive, ElementRef, Input } from '@angular/core';

@Directive({ selector: '[scrollViewPortCustomHeight]' })
export class ScrollViewPortCustomHeightDirective implements AfterViewInit {
  @Input() optionsLength: number;
  @Input() itemSize: number;

  private cellsForSmall = 6;
  private cellsForLarge = 8;
  private height = this.viewport.getViewportSize().height;
  private itemHeight = 66;

  constructor(private el: ElementRef, private viewport: ViewportRuler) {}

  ngAfterViewInit(): void {
    this.calculateStyles();
  }

  private calculateStyles(): void {
    const visibleItems = this.visibleItems();

    this.el.nativeElement.style.height = `${this.itemHeight * visibleItems}px`;
    this.el.nativeElement.style.marginTop = '0px';
  }

  private visibleItems(): number {
    const maxItemsHeight = this.optionsLength * this.itemHeight;
    if (maxItemsHeight < this.height) {
      return this.optionsLength;
    }
    return this.height > 800 && this.optionsLength > this.cellsForSmall ? this.cellsForLarge : this.cellsForSmall;
  }
}
